export const format = {
  methods: {
    formatCurrencyDisplay (value) {
      return value.toLocaleString('en-US', { minimumFractionDigits:2, maximumFractionDigits:2 })
    }
  }
}